<template>
  <div class="block-container">
    <div class="header">
      <img v-lazy="$global.imgUrl + block.perImg" alt="" v-if="block.perImg" />
      <img :src="require('@/assets/img/details/qikan.png')" alt="" v-else />
      <router-link
        target="_blank"
        :to="{
          path: '/bkzxdetail',
          query: { title: '百科在线', id: block.perId },
        }"
        ><h2>{{ block.perName }}</h2></router-link
      >
    </div>
    <div class="block-main">
      <div class="top">
        <div class="title">
          <span @click="goDetail(block)">{{ block.title }}</span>
        </div>
        <div class="time">
          {{ new Date(block.createTime).toLocaleDateString() }}
        </div>
      </div>
      <div class="content">
        {{ block.summary }}
      </div>
      <div class="bottom">
        <img class="icon" v-lazy="require('@/assets/img/qietu/fly.png')" />
        <a
          :href="`https://www.baikezaixian.com/details?ids=${block.perId}`"
          target="_blank"
          >在线投稿</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    block: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    goDetail(e) {
      window.open(`/admin/solicitationDetails?id=${e.id}&type=10`, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.block-container {
  // height: 280px;
  margin-bottom: 9px;
  padding: 17px 0 27px 0;
  border: 1px solid #a7c0eb;
  border-radius: 10px;
  .header {
    height: 70px;
    border-bottom: 1px solid #7f7f7f;
    cursor: pointer;
    img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin-left: 36px;
      margin-right: 11px;
      vertical-align: middle;
    }
    h2 {
      display: inline-block;
      vertical-align: middle;
      font-size: 30px;
      font-weight: bold;
      color: #263d78;
    }
  }
  .block-main {
    padding: 20px 25px;
    .top {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 18px;
        font-weight: bold;
        color: #263d78;
        width: 750px;
        a {
          color: #263d78;
        }
        cursor: pointer;
      }
      .column {
        color: #079abe;
      }
      .time {
        font-size: 12px;
        color: #666666;
      }
    }
    .content {
      width: 750px;
      height: 54px;
      line-height: 2;
      margin-top: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; //行数
      -webkit-box-orient: vertical;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
    }
    .bottom {
      margin-top: 15px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 112px;
      height: 37px;
      background: #ffffff;
      border: 1px solid #dfe8f2;
      cursor: pointer;
      a {
        color: #333333;
      }
      .icon {
        width: 19px;
        height: 19px;
      }
    }
  }
}
</style>
